'use strict';

const $sectionCaseSlide = document.querySelector('.section-case-slide');
if ($sectionCaseSlide) {
  let $progress = $sectionCaseSlide.querySelector('.slide-1-progress');
  let $progressBar = $progress.querySelector('.slide-1-progress__bar');
  let option = {
    type: 'slide',
    focus: 'left',
    perPage: 1,
    perMove: 1,
    fixedWidth: '73.8666666666vw',
    gap: '15px',
    trimSpace: false,
    padding: {
      right: '20px',
      left: '20px'
    },
    speed: 400,
    autoplay: 'pause',
    interval: 0,
    arrows: true,
    pagination: false,
    drag: true,
    mediaQuery: 'min',
    breakpoints: {
      750: {
        perPage: 4,
        trimSpace: true,
        omitEnd: true,
        fixedWidth: '29.0789473684vw',
        gap: '1.9736842105vw'
      },
      1520: {
        perPage: 4,
        trimSpace: true,
        omitEnd: true,
        fixedWidth: '442px',
        gap: '30px',
        padding: {
          right: 'calc(((100% - 1520px) / 2) + 20px)',
          left: 'calc(((100% - 1520px) / 2) + 20px)'
        }
      }
    }
  };
  let splide = new Splide($sectionCaseSlide, option);
  splide.on('mounted move', () => {
    let end = splide.Components.Controller.getEnd() + 1;
    let rate = Math.min((splide.index + 1) / end, 1);
    $progressBar.style.width = `${String(100 * rate)}%`;
  });
  splide.mount();
};